import { getUser } from '@/graphql/user'
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'

export function getViewedUserInfo (userId) {
  const store = useStore()
  const user = ref({})
  if (userId) {
    getUser(userId).then(data => {
      user.value = data
    })
  } else {
    user.value = store.state.user
  }
  return { user }
}

export function getCollapseItems (user) {
  const { t } = useI18n()
  const collapseItems = computed(() => {
    const items = [
      {
        children: [
          {
            key: 'performanceObjective',
            title: t('okr.titles.objectiveTitle'),
            afterTitle: `（${t('shared.weight')}: 80%）`
          }
        ],
        activeKey: ['performanceObjective']
      },
      {
        children: [
          {
            key: 'individualDevelopment',
            title: t('okr.titles.normalTitle'),
            afterTitle: `（${t('shared.weight')}: 20%）`
          }
        ],
        activeKey: ['individualDevelopment']
      },
      {
        children: [
          {
            key: 'review',
            title: t('okr.titles.review')
          }
        ],
        activeKey: []
      }
    ]
    if (!user.value.isMyManagementScope) {
      items.splice(1, 1)
      if (user.value.isPerformanceLeader) {
        items[0].children[0].afterTitle = `（${t('shared.weight')}: 70%）`
      }
    } else if (user.value.isPerformanceLeader) {
      items[1].children[0].title = t('okr.titles.leaderTitle')
      items[0].children[0].afterTitle = `（${t('shared.weight')}: 70%）`
      items[1].children[0].afterTitle = `（${t('shared.weight')}: 30%）`
    }
    return items
  })

  return collapseItems
}
